import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router'
import dayjs from 'dayjs'
import { EditOutlined, DeleteOutlined, Add as AddIcon } from '@mui/icons-material'
import { useActionApi } from 'hooks'
import Api from 'api'
import TopBarRedesigned from "components/TopBarRedesigned/TopBarRedesigned";
import FixedLoader from 'components/FixedLoader'
import FixedError from 'components/FixedError'
import {
  BasicContainer,
  NotificationBox,
  ButtonContainer,
  Card,
  Title,
  LocationContainer,
  LocationIcon,
  PaymentTermsCard,
  ShiftDetailsCard,
  IconWrapper,
  ActionButton,
  RemoveButton,
  PaymentTermsTitle,
  AttachMoneyIcon,
  AccessTimeIcon,
  EventIcon,
  NotificationsOutlinedIcon,
  ButtonIcon
} from './JobPostedPage.styles'

import { exitReact, getPaymentTerms } from 'utils';
import clsx from 'clsx'

export default function JobPostedPage() {
  const history = useHistory()
  const [job, setJob] = useState<any>(null)
  const [showConfirmRemove, setShowConfirmRemove] = useState(false)


  const onInfoLinkClick = (infoLink: string) => {
    // @ts-ignore
    window.Cordova ? cordova.InAppBrowser.open(
      infoLink,
      '_system',
      'location=yes'
    )
    : window.open(
      infoLink,
      '_blank',
      'location=yes'
    )
  }

  useEffect(() => {
    const loadJob = async () => {
      const { id } = history.location.state as any
      if (id) {
        try {
          const jobData = await Api.getJobDetails(id)
          setJob(jobData)
        } catch (err) {
          console.error('Error loading job:', err)
          history.push('home')
        }
      }
    }
    loadJob()
  }, [history])

  const goHome = () => {
    history.push('loading')
    exitReact('home')
  }

  const [removeJobLoading, removeJobError, removeJob] = useActionApi({
    apiMethod: Api.removeJob,
    onSuccess: goHome,
  })

  if (!job) {
    return null
  }

  if (!job.shifts || !Array.isArray(job.shifts) || !job.shifts.length) {
    console.error('Job shifts data is invalid');
    goHome();
    return;
  }

  const handleModifyHours = () => {
    if (!job?.shifts?.length) {
      console.error('Job shifts data is invalid');
      return;
    }
    history.push('modifyJob', { job })
  }

  const handleRemoveShift = () => {
    setShowConfirmRemove(true)
  }

  const handleConfirmRemove = async () => {
    await removeJob(job.id)
  }

  const handleBookAnother = () => {
    if (!job?.shifts?.length) {
      console.error('Job or shifts are undefined');
      return;
    }
    history.push('postJob', { date: job.shifts[0].shiftDate })
  }

  return (
    <>
      <TopBarRedesigned
        title="Posted Shift"
        onBack={goHome}
      />

      <BasicContainer>
        <Card>
          <Title>
            {job.type === 1 ? 'Dental Assistant' : 'Dental Hygienist'} Shift
          </Title>

          <LocationContainer>
            <LocationIcon />
              <div>{`${job.location.address}, ${job.location.city}, ${job.location.province} ${job.location.postalCode}`}</div>
          </LocationContainer>
        </Card>

        <PaymentTermsCard>
            <PaymentTermsTitle>
                <AttachMoneyIcon />
                Payment Terms
            </PaymentTermsTitle>
          <div>Your posted payment terms for this shift are:</div>
          <div className="payment-terms">{getPaymentTerms(job.paymentTerms)}</div>
          <a 
            className={clsx("reminder", "no-fastclick")}
            onClick={() => onInfoLinkClick('https://www.tempstars.com/direct_payment/')}
          >
            Just a friendly reminder
          </a>        </PaymentTermsCard>

        <ShiftDetailsCard>
          <div className="shift-row">
            <IconWrapper>
              <EventIcon />
              <span className="shift-row-title">Date</span>
            </IconWrapper>
            <span>{dayjs(job.shifts[0].shiftDate).format('MMM D, YYYY')}</span>
          </div>

          <div className="shift-row">
            <IconWrapper>
              <AccessTimeIcon />
              <span className="shift-row-title">Hours</span>
            </IconWrapper>
            <span>{`${job.shifts[0].postedStart} - ${job.shifts[0].postedEnd}`}</span>
          </div>

          {job.hasBonus && (
            <div className="shift-row">
              <IconWrapper>
                <AttachMoneyIcon />
                <span className="shift-row-title">Bonus</span>
              </IconWrapper>
              <span>{`+$${job.bonus}/hr incentive bonus`}</span>
            </div>
          )}
        </ShiftDetailsCard>

        <NotificationBox>
            <NotificationsOutlinedIcon type="warning" />
            {`Your shift is not yet filled. Every ${job.type === 1 ? 'assistant' : 'hygienist'} within 110km of your office has been notified of your posting.

            With over 8000 ${job.type === 1 ? 'assistant' : 'hygienist'} members the chances of your shift being filled is high!

            You'll be notified immediately by e-mail when you receive an Offer from ${job.type === 1 ? 'an assistant' : 'a hygienist'} to review.

            ${job.Instabook === 0 ? 'Remember, you can Enable Insta-booking on your shifts to increase your chances of filling your shift even more!' : ''}`}
        </NotificationBox>

        <ButtonContainer>
          <ActionButton
            variant="outlined"
            onClick={handleModifyHours}
            className={clsx("outlined", "no-fastclick")}
          >
            <ButtonIcon><EditOutlined /></ButtonIcon>
            Change Shift Hours
          </ActionButton>

          <RemoveButton
            variant="outlined"
            onClick={showConfirmRemove ? handleConfirmRemove : handleRemoveShift}
            color="error"
            className={clsx("outlined", "no-fastclick")}
          >
            <ButtonIcon className="error">
              <DeleteOutlined />
            </ButtonIcon>
            {showConfirmRemove ? 'Tap/click again to confirm' : 'Remove Shift'}
          </RemoveButton>

          <ActionButton
            variant="contained"
            onClick={handleBookAnother}
            className={clsx("contained", "no-fastclick")}
          >
            <ButtonIcon><AddIcon /></ButtonIcon>
            Book another temp for this date
          </ActionButton>
        </ButtonContainer>

        <FixedLoader
          loading={removeJobLoading}
        />
        <FixedError error={removeJobError}/>
      </BasicContainer>
    </>
  )
}
